<template>
  <div>
    <PageTitle title="Create Event" :backBtn="true" :showLoading="isLoading" />

    <ValidationObserver ref="observer" v-slot="{ validate, reset }">
      <v-container fluid class="lighten-12">
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-title>General</v-card-title>
              <v-container fluid class="light gray lighten-12 container-card">
                <v-row>
                  <v-col lg="4" md="6" sm="7">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Title"
                      rules="required"
                    >
                      <v-text-field
                        v-model="event.title"
                        :error-messages="errors"
                        label="Title"
                        dense
                        outlined
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col lg="4" md="6" sm="1"></v-col>
                  <v-col lg="4" md="6" sm="4">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="All Day"
                      rules="required"
                    >
                      <v-switch
                        v-model="event.all_day"
                        flat
                        label="All Day"
                        :error-messages="errors"
                      ></v-switch>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col lg="4" md="6" sm="6">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="StartDate"
                    >
                      <datePickComponent
                        v-if="event.all_day == true"
                        labelname="Start Date"
                        v-model="event.start"
                        :error-messages="errors"
                      />

                      <date-picker
                        v-if="event.all_day == false"
                        v-model="event.start"
                        type="datetime"
                        placeholder="Start Date & Time"
                        @input-error="errors"
                      ></date-picker>
                    </ValidationProvider>
                  </v-col>
                  <v-col lg="4" md="6" sm="6">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="EndDate"
                    >
                      <datePickComponent
                        v-if="event.all_day == true"
                        labelname="End Date"
                        v-model="event.end"
                        :error-messages="errors"
                      />
                      <date-picker
                        v-if="event.all_day == false"
                        placeholder="End Date & Time"
                        v-model="event.end"
                        type="datetime"
                      ></date-picker>
                    </ValidationProvider>
                  </v-col>
                  <v-col lg="4" md="6" sm="6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Event Type"
                      rules="required"
                    >
                      <v-select
                        outlined
                        dense
                        item-text="name"
                        item-value="id"
                        v-model="event.event_type_id"
                        :items="eventTypes"
                        :error-messages="errors"
                        label="Event Type"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col lg="4" md="6" sm="6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Repeat"
                      rules="required"
                    >
                      <v-select
                        outlined
                        dense
                        item-text="name"
                        item-value="id"
                        v-model="event.repeat"
                        :items="repeats"
                        :error-messages="errors"
                        label="Repeat"
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col lg="4" md="6" sm="6">
                    <v-text-field
                      v-if="event.repeat == 'Never'"
                      v-model="event.repeat_end"
                      label="Repeat End Date"
                      dense
                      disabled
                      outlined
                    ></v-text-field>
                    <ValidationProvider
                      rules="required"
                      v-else
                      v-slot="{ errors }"
                      name="Repeat End Date"
                    >
                      <datePickComponent
                        labelname="Repeat End Date"
                        v-model="event.repeat_end"
                        :error-messages="errors"
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col lg="4" md="6" sm="6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Visibility"
                      rules="required"
                    >
                      <v-select
                        outlined
                        dense
                        item-text="name"
                        item-value="id"
                        v-model="event.visibility"
                        :items="visibilitys"
                        :error-messages="errors"
                        label="Visibility"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col lg="12" md="6" sm="12">
                    <ValidationProvider v-slot="{ errors }" name="Description">
                      <v-textarea
                        rows="3"
                        outlined
                        v-model="event.description"
                        label="Description"
                        :error-messages="errors"
                      ></v-textarea>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <v-col cols="12" class="text-right pa-0">
          <v-btn
            depressed
            small
            class="ml-1 text-white btn_medium"
            @click="clear"
            >Clear</v-btn
          >
          <v-btn
            depressed
            small
            :disabled="isDisabled"
            class="text-white btn_blue btn_medium w-100"
            @click="submitEvent"
            >Submit</v-btn
          >
        </v-col>
      </v-container>
    </ValidationObserver>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import datePickComponent from '@/components/base/DateComponent';
import { required, numeric } from 'vee-validate/dist/rules';
import axios from '@/plugins/axios';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';

import { Event } from '../../models/Event';
extend('required', {
  ...required,
  message: '{_field_} is required',
});

export default {
  data: () => ({
    isLoading: false,
    nullDatetime: null,
    datetime: new Date(),
    datetimeString: '2019-01-01 12:00',
    formattedDatetime: '09/01/2019 12:00',
    textFieldProps: {
      appendIcon: 'event',
    },
    dateProps: {
      headerColor: 'blue',
    },
    timeProps: {
      useSeconds: true,
      ampmInTitle: true,
    },
    event: new Event(),
    dialog: false,
    isDisabled: false,
    show: false,
    errors: [],
    repeats: [
      { id: 'Never', name: 'Never' },
      { id: 'Every Day', name: 'Every Day' },
      { id: 'Every Week', name: 'Every Week' },
      { id: 'Every Month', name: 'Every Month' },
      { id: 'Every Year', name: 'Every Year' },
    ],
    visibilitys: [
      { id: 'Public', name: 'Public' },
      { id: 'Private', name: 'Private' },
    ],
    staffs: [],
    eventTypes: [],
  }),
  name: 'AddBatch',
  components: {
    ValidationProvider,
    ValidationObserver,
    datePickComponent,
    DatePicker,
  },
  computed: {},
  methods: {
    clear() {
      this.event = new Event();
    },
    async submitEvent() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.createEvent();
      }
    },
    createEvent() {
      this.isDisabled = true;
      axios
        .post(`events`, new Event().toRequestModel(this.event))

        .then((res) => {
          this.isLoading = false;
          this.isDisabled = false;
          this.$toast.success('Event created successfully.');
          this.event = new Event();
          this.$router.push('/event');
        })
        .catch((err) => {
          this.isDisabled = false;
          this.isLoading = false;
          this.$toast.error('Failed to create event.');
          this.event = new Event();
        });
    },

    GetEventsType() {
      axios
        .get(`event-type`)
        .then((res) => {
          this.eventTypes = res.data.data;
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
  },
  created() {
    this.GetEventsType();
  },
};
</script>
<style scoped>
.mx-datepicker {
  width: 360px;
}
</style>
